import { render } from "./loading-panel.vue?vue&type=template&id=5cb81152"
import script from "./loading-panel.vue?vue&type=script&lang=js"
export * from "./loading-panel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__